import React, { Component } from 'react';

import TeamMemberBox from '../common/team-member-box';
import LoadingIndication from '../common/loading-indicator';
import AnimatedWrapper from '../core/animated-wrapper';
import shareService from '../../services/share';
import teamMembersService from '../../services/team-members';
import SmartAd from '../ads/smart-ad';
import AdUIService from '../../services/ads/ui';

import './team-members.css';

class TeamMembers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      isError: false,
      members: [],
    };

    shareService.setupPage({
      title: "Our Team",
      // isTitlePrefixOn: false,
      tags: ["javascript", "webdev"]
    });
  }

  componentDidMount() {
    teamMembersService.getAll()
      .then((members) => {
        this.setState({
          isLoading: false,
          members,
        });
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
          isError: true
        });
      });
  }
  
  getMembersPartJSX() {
    if (this.state.members.length === 0) {
      return (
        <p>There is no team members</p>
      );
    }

    const members = this.state.members.map((member, i) => 
      <TeamMemberBox {...member} isOnlyTwitterMediaShown={ false } key={`team-member-${i}`} />
    );

    return members;
  }

  render() {
    let extraJSX;
    
    if (this.state.isLoading) {
      extraJSX = (
        <LoadingIndication />
      );
    }
    else {
      extraJSX = (
        <div className='members'>
          { this.getMembersPartJSX() }
        </div>
      );
    }

    return (
      <section className='regular-page team-members-page'>
        <div className='team-members-container'>
          <h3 className='page-title'>Our Team</h3>
          <hr className='title-separator' />

          {extraJSX}
        </div>
      </section>
    );
  }
}

const AnimatedTeamMembers = AnimatedWrapper(TeamMembers);
export default AnimatedTeamMembers;